import {Alert, Modal, Spinner} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import styles from './ImpactConfirmModal.module.css'

interface ImpactConfirmModalProps {
    show: boolean
    onHide: () => void
    onConfirm: () => void
    icon?: React.ReactNode
    title: string
    body: React.ReactNode
    confirmLabel: string
    isLoading?: boolean
    error?: string
}

const ImpactConfirmModal: React.FC<ImpactConfirmModalProps> = ({
    show,
    onHide,
    onConfirm,
    icon,
    title,
    body,
    confirmLabel,
    isLoading = false,
    error
}) => {
    const {t} = useTranslation('common')

    const handleClose = () => {
        if (isLoading) return
        onHide()
    }

    return (
        <Modal
            show={show}
            onHide={handleClose}
            centered
            backdrop={isLoading ? 'static' : true}
            keyboard={!isLoading}
            className={styles.modal}
            contentClassName={styles.modalContent}
        >
            <Modal.Body className={styles.modalBody}>
                <div className={styles.headerRow}>
                    {icon}
                    <h2 className={styles.title}>{title}</h2>
                </div>

                <p className={styles.description}>{body}</p>

                {error && (
                    <Alert variant="danger" className="mb-3">
                        {error}
                    </Alert>
                )}

                <div className={styles.buttons}>
                    <button
                        type="button"
                        className={styles.primaryButton}
                        onClick={onConfirm}
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <>
                                <Spinner size="sm" animation="border"/>
                                {confirmLabel}
                            </>
                        ) : (
                            confirmLabel
                        )}
                    </button>
                    <button
                        type="button"
                        className={styles.cancelLink}
                        onClick={handleClose}
                        disabled={isLoading}
                    >
                        {t('actions.cancel')}
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default ImpactConfirmModal
